import { InjectionToken } from '@angular/core';

export interface EnvironmentConfig {
  production: boolean;
  idsApiUrl: string;
  lsApiUrl: string;
  mpApiUrl: string;
  fluencyApiUrl: string;
  screenerApiUrl: string;
  phonicsApiUrl: string;
  grammarApiUrl: string;
  academyApiUrl: string;
  mpCoachUrlStudent: string;
  mpCoachUrlNonStudent: string;
  mpAccountUrl: string;
  mpManagerUrl: string;
  lsV10Url: string;
  statsPageUrl: string;
  cleverClientId: string;
  classLinkClientId: string;
  gg4lClientId: string;
  googleClientId: string;
  googleMapsApiKey: string;
  microsoftSSOClientId: string;
  version: string;
  applicationInsightsConnectionString: string;
  sandboxCustomerId: number;
  environment: ENV_CONFIG_ENV_TYPES;
}

export enum ENV_CONFIG_ENV_TYPES {
  DEV = 'dev',
  QA = 'qa',
  DEMO = 'demo',
  PROD = 'prod',
  MASTER = 'master',
}

export const ENV_CONFIG = new InjectionToken<EnvironmentConfig>('EnvironmentConfig');
